module.exports = __webpack_public_path__ + "img/ic_32_register_google-active.33bbbfd8.svg";